export const wageJurisdictionKeys = {
  all: ['wageJurisdiction'] as const,
  list: (params?: (string | number | undefined)[]) =>
    [...wageJurisdictionKeys.all, 'list', ...(params ?? [])] as const,
  byId: (id: number) => [...wageJurisdictionKeys.all, id] as const,
}

export const wageRuleKeys = {
  all: ['wageRule'] as const,
  list: (params?: (string | number | undefined)[]) =>
    [...wageRuleKeys.all, 'list', ...(params ?? [])] as const,
  byId: (id: number) => [...wageRuleKeys.all, id] as const,
}
